var map = {
	"./creditcard/mastercard.svg": 87702,
	"./creditcard/visa.svg": 96305,
	"./dashed_border.svg": 92466,
	"./icons.svg": 38680,
	"./logo.svg": 72539,
	"./logo_icon.svg": 88677,
	"./partners/knab-logo.svg": 61192,
	"./pay_methods/ach_transfer.png": 88107,
	"./pay_methods/afterpay.png": 75901,
	"./pay_methods/bancontact.png": 96908,
	"./pay_methods/bank_transfer.png": 121,
	"./pay_methods/blik.png": 81731,
	"./pay_methods/creditcard.png": 68740,
	"./pay_methods/ideal.png": 89702,
	"./pay_methods/ideal_qr.png": 72026,
	"./pay_methods/klarna.png": 48282,
	"./pay_methods/paypal.png": 77372,
	"./pay_methods/sepa.png": 50096,
	"./pay_methods/square_icons/ach-transfer.png": 34228,
	"./pay_methods/square_icons/afterpay.png": 64908,
	"./pay_methods/square_icons/bancontact.png": 91097,
	"./pay_methods/square_icons/bank-transfer.png": 44652,
	"./pay_methods/square_icons/blik.png": 1414,
	"./pay_methods/square_icons/creditcard.png": 66725,
	"./pay_methods/square_icons/direct-debit.png": 76138,
	"./pay_methods/square_icons/ideal-qr.png": 35645,
	"./pay_methods/square_icons/ideal.png": 58893,
	"./pay_methods/square_icons/klarna-paynow.png": 45916,
	"./pay_methods/square_icons/paypal.png": 96809,
	"./pay_methods/square_icons/paypro.png": 61735,
	"./payment_page/discount_code.svg": 50532,
	"./payment_page/testimonial_arrow.svg": 83668,
	"./payment_page/testimonial_star.svg": 47961,
	"./services/arrow.svg": 96964,
	"./services/blue-check.svg": 45526,
	"./services/green-check.svg": 14617,
	"./services/label.svg": 63917,
	"./socials/logo-whatsapp.svg": 36523,
	"./trackers/facebook-pixel.svg": 6155,
	"./trackers/google-tag-manager.svg": 87960,
	"./waves.png": 66747
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82672;